<template>
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="EyeIcon"
      title="preview"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="showPreview(params.DocName, params.CollectionName, params.Data)"
    />

    <vs-popup
      mailpopup
      class="holamundo customnewpopup"
      title="Mail Preview"
      :active.sync="popupActiveMail"
    >
      <div class="tab-text">
        <div class="vx-row" style="width: 622px">
          <div class="vx-col md:w-1/1 w-full mt-4">
            <h3>Subject: {{ welcomeMailSubject }}</h3>
          </div>
          <br />
          <div v-html="welcomeMailText"></div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moduleMailtplManagement from "@/store/mailtpl-management/moduleMailtplManagement.js";
export default {
  name: "CellRendererActions",
  data() {
    return {
      popupActiveMail: false,
      welcomeMailSubject: "",
      welcomeMailText: "",
    };
  },
  methods: {
    showPreview(DocName, CollectionName, Data) {
      this.$store
        .dispatch("mailtplManagement/fetchMailtpl", { DocName, CollectionName })
        .then((res) => {
          console.log("res====", res.data);
          this.welcomeMailSubject = res.data.subject;
          this.welcomeMailText = res.data.html;
          this.popupActiveMail = true;
        });
    },
  },
  created() {
    if (!moduleMailtplManagement.isRegistered) {
      this.$store.registerModule("mailtplManagement", moduleMailtplManagement);
      moduleMailtplManagement.isRegistered = true;
    }
  },
};
</script>